@if (environment.isTest || !environment.production) {
    <button mat-flat-button class="cb-environment">{{ environment.envName }}</button>
}
